export enum Through {
    WAREHOUSE = 'Warehouse',
    CARRIER = 'Carrier',
    OEM = 'OEM',
    CUSTOMER = 'Customer',
    INVALID_COD = 'Invalid COD',
    UNABLE_TO_CONFIRM = 'Unable to Confirm'
}
